import type { ReactNode } from 'react';

export type BrandSlideProps = {
  /** Tagline under the wordmark. */
  tagline?: ReactNode;
  /** Logo src. Default the white wordmark (use on a dark slide). */
  logo?: string;
  alt?: string;
};

export function BrandSlide({ tagline, logo = '/assets/logo-white.svg', alt = 'StreamNative' }: BrandSlideProps) {
  return (
    <div className="slide-body sn-brand">
      <img className="sn-brand-logo" src={logo} alt={alt} />
      {tagline && <p className="sn-brand-tagline">{tagline}</p>}
    </div>
  );
}
